/* Back in stock sign-up (22.10.2026): opens the modal from any .bis-notify button and subscribes the
   e-mail to the selected variant through the Klaviyo client API (metric "Subscribed to Back in Stock"). */
(function () {
  var modal = document.getElementById('bis-modal');
  if (!modal) return;
  /* move the modal out of the sticky product column: a transformed ancestor would turn position:fixed into a local box */
  if (modal.parentNode !== document.body) document.body.appendChild(modal);
  var cfg = JSON.parse(document.getElementById('bis-modal-config').textContent);
  var q = function (s) { return modal.querySelector(s); };
  var lastFocus = null, data = null;
  function fill(tpl, d) { return tpl.replace(/%SIZE%/g, d.bisSize || '').replace(/%DATE%/g, d.bisEta || '').replace(/%COLOURS%/g, d.bisAlts || ''); }
  function open(btn) {
    var main = document.getElementById('AddToCart');
    var source = (main && main.dataset.bisVariantId) ? main : btn;
    if (!source.dataset.bisVariantId) return;
    data = {}; for (var k in source.dataset) data[k] = source.dataset[k];
    lastFocus = btn;
    q('.bis-modal__form').hidden = false; q('.bis-modal__success').hidden = true; q('.bis-modal__error').hidden = true;
    var img = q('.bis-modal__img'); img.src = data.bisImage || ''; img.alt = data.bisProduct || '';
    var colour = (data.bisColor && data.bisProduct && data.bisProduct.toLowerCase().indexOf(data.bisColor.toLowerCase()) === -1) ? data.bisColor : '';
    q('.bis-modal__product').textContent = [data.bisProduct, colour, data.bisSize].filter(Boolean).join(' · ');
    q('.bis-modal__text').textContent = data.bisEta ? fill(cfg.strings.bodyEta, data) : cfg.strings.bodyNoEta;
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('bis-open');
    setTimeout(function () { q('#bis-email').focus(); }, 50);
  }
  function close() {
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('bis-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bis-notify');
    if (btn) { e.preventDefault(); open(btn); return; }
    var scroll = e.target.closest('[data-bis-scroll]');
    if (scroll) { e.preventDefault(); var t = document.querySelector(scroll.getAttribute('data-bis-scroll')); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (e.target.closest('[data-bis-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  q('.bis-modal__form').addEventListener('submit', function (e) {
    e.preventDefault();
    var input = q('#bis-email'), err = q('.bis-modal__error'), btn = q('.bis-modal__submit');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = cfg.strings.invalid; err.hidden = false; input.focus(); return; }
    var label = btn.textContent; btn.disabled = true; btn.textContent = cfg.strings.sending; err.hidden = true;
    var payload = { data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + data.bisVariantId } } } } };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      /* language of the page the customer signed up on -> profile property "Back in Stock Language"; the flow splits DE/EN on it.
         The sign-up endpoint rejects profile properties, so this is a second, non-blocking call. */
      if (cfg.lang) {
        fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(cfg.companyId), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: { 'Back in Stock Language': cfg.lang } } } })
        }).catch(function () {});
      }
      q('.bis-modal__success-text').textContent = fill(data.bisEta ? cfg.strings.successEta : cfg.strings.successNoEta, data);
      var alt = q('.bis-modal__success-alt');
      if (data.bisAlts) { alt.textContent = fill(cfg.strings.successAlt, data); alt.hidden = false; } else { alt.hidden = true; }
      q('.bis-modal__form').hidden = true; q('.bis-modal__success').hidden = false; q('.bis-modal__done').focus();
    }).catch(function () {
      err.textContent = cfg.strings.error; err.hidden = false;
    }).then(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
